/* Anclas de Reservas (/reservas/#reserva-condiciones, #reserva-datos,
   #reserva-reclamaciones). Desde el 2026-10-13 Reservas es una página propia:
   el ancla es nativa, pero aquí se abre el acordeón y se espera a que la
   vegetación y ScrollTrigger midan antes de desplazar. Acepta también los
   enlaces antiguos de la SPA (#reservas/condiciones). */
(function () {
  'use strict';
  var page = document.getElementById('page-reservas');
  if (!page) return;
  var targets = { condiciones: 'reserva-condiciones', datos: 'reserva-datos', reclamaciones: 'reserva-reclamaciones' };
  var pending, refreshTimer;
  var shell = document.getElementById('app-shell');
  function refreshLayout() {
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function () {
      if (page.hidden) return;
      if (window.ScrollTrigger) window.ScrollTrigger.refresh();
      if (window.Vines) window.Vines.rebuild();
    }, 280);
  }
  function destino() {
    var h = location.hash.slice(1), r = h.split('/');
    if (r[0] === 'reservas' && targets[r[1]]) return targets[r[1]];
    for (var k in targets) if (targets[k] === h) return h;
    return null;
  }
  function visitAnchor() {
    var id = destino(), hash = location.hash;
    if (!id || page.hidden) return;
    // El transform de entrada cambia el marco fijo y la posición visual.
    // Espera a su fin antes de medir o desplazar un enlace de carga directa.
    if (shell && (shell.classList.contains('pre-reveal') || getComputedStyle(shell).transform !== 'none')) return;
    var target = document.getElementById(id);
    if (!target) return;
    var focusTarget = target;
    if (target.tagName === 'DETAILS') {
      if (window.HotelAccordion) window.HotelAccordion.open(target);
      else target.open = true;
      focusTarget = target.querySelector('summary');
    }
    // Dos frames dejan que la página recién activada se mida. Si el destino es un tema del acordeón, además se espera a que
    // termine de abrirse y de cerrarse el anterior (el espacio del tema que se cierra se recoge después de 100 ms): medir
    // antes dejaba el tema fuera de lugar. Con movimiento reducido no hay animación y no se espera.
    var calmado = target.tagName === 'DETAILS' && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    function medir() {
      if (page.hidden || location.hash !== hash) return;
      // offsetTop (y no getBoundingClientRect): ignora la entrada animada (.rd-in, translateY) que aún no terminó.
      var top = 0, node = target;
      while (node) { top += node.offsetTop; node = node.offsetParent; }
      var nav = document.getElementById('nav');
      var frame = nav ? Math.max(0, nav.getBoundingClientRect().bottom) : 80;
      var root = document.documentElement, previous = root.style.scrollBehavior;
      root.style.scrollBehavior = 'auto';
      getComputedStyle(root).scrollBehavior;
      focusTarget.focus({ preventScroll: true });
      window.scrollTo(0, Math.max(0, top - frame - 24));
      root.style.scrollBehavior = previous;
    }
    // Las fotos de carga diferida que quedan por encima del destino cambian de alto al llegar y lo desplazan después
    // de medir: se fuerzan a cargar y se espera a que terminen (con un tope) antes de medir.
    function esperarImagenesPrevias(listo) {
      var previas = [].slice.call(document.images).filter(function (img) {
        return !img.complete && (target.compareDocumentPosition(img) & Node.DOCUMENT_POSITION_PRECEDING);
      });
      if (!previas.length) { listo(); return; }
      var pendientes = previas.length, fin = false;
      function terminar() { if (!fin) { fin = true; listo(); } }
      function una() { pendientes -= 1; if (pendientes <= 0) terminar(); }
      previas.forEach(function (img) {
        img.loading = 'eager';
        img.addEventListener('load', una, { once: true });
        img.addEventListener('error', una, { once: true });
      });
      setTimeout(terminar, 2000);
    }
    requestAnimationFrame(function () { requestAnimationFrame(function () {
      esperarImagenesPrevias(function () {
        // Una segunda medición corrige el reajuste del ancla que hace el navegador mientras termina de cargar; se cancela
        // si la persona toca, gira la rueda o pulsa una tecla.
        function dosVeces() {
          medir();
          var movio = false;
          function parar() { movio = true; }
          ['wheel', 'touchstart', 'keydown', 'mousedown'].forEach(function (ev) { window.addEventListener(ev, parar, { once: true, passive: true }); });
          setTimeout(function () { if (!movio) medir(); }, 900);
        }
        if (calmado) setTimeout(dosVeces, 480); else dosVeces();
      });
    }); });
  }
  function scheduleAnchor() {
    clearTimeout(pending);
    pending = setTimeout(visitAnchor, 120);
  }
  window.addEventListener('hashchange', scheduleAnchor);
  document.addEventListener('i18n:change', refreshLayout);
  var activation = new MutationObserver(scheduleAnchor);
  activation.observe(page, { attributes: true, attributeFilter: ['hidden'] });
  if (shell) {
    activation.observe(shell, { attributes: true, attributeFilter: ['class'] });
    shell.addEventListener('transitionend', function (event) {
      if (event.target === shell && event.propertyName === 'transform') scheduleAnchor();
    });
  }
  // Volver a pulsar la misma ancla debe funcionar sin un nuevo hashchange.
  document.querySelectorAll('[data-reserva-anchor]').forEach(function (link) {
    link.addEventListener('click', function () {
      if (link.hash === location.hash) scheduleAnchor();
    });
  });
  page.querySelectorAll('.faq-item').forEach(function (item) {
    item.addEventListener('toggle', function () { refreshLayout(); });
  });

  // «Reservar» del header y de la barra inferior estando ya en Reservas:
  // app.js anula la navegación (es la misma página) y aquí se lleva a la
  // persona al formulario, que es lo que buscaba. No se
  // llama a preventDefault: app.js lo hace después de cerrar el menú, y si
  // lo hiciéramos antes el menú quedaría abierto. «Completar el formulario»
  // (portada y bloque de confianza, [data-ir-formulario]) baja al formulario mismo.
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  function irA(destinoEl, focoEl) {
    if (!destinoEl || page.hidden) return;
    requestAnimationFrame(function () {
      var top = 0, node = destinoEl;
      while (node) { top += node.offsetTop; node = node.offsetParent; }
      var nav = document.getElementById('nav');
      var frame = nav ? Math.max(0, nav.getBoundingClientRect().bottom) : 80;
      if (focoEl) {
        if (!focoEl.hasAttribute('tabindex')) focoEl.setAttribute('tabindex', '-1');
        focoEl.focus({ preventScroll: true });
      }
      // 48 y no 24: deja a la vista la nota «Campos obligatorios», que en
      // escritorio sobresale por encima del formulario.
      // 'instant' y no 'auto': 'auto' hereda el scroll-behavior:smooth de <html>.
      window.scrollTo({ top: Math.max(0, top - frame - 48), behavior: reduce.matches ? 'instant' : 'smooth' });
    });
  }
  document.addEventListener('click', function (e) {
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    if (e.target.closest('.hdr-book, .bar-book')) {
      // Rediseño 2026-10-29: la sección del formulario (en móvil .rv-info
      // es display: contents y no tiene caja que medir).
      irA(page.querySelector('.rvd-reserva') || page.querySelector('.rv-info'), document.getElementById('rvd-form-titulo') || page.querySelector('.rv-info h2'));
    } else if (e.target.closest('[data-ir-formulario]')) {
      e.preventDefault();
      irA(document.getElementById('reservaForm'), document.getElementById('reservaForm'));
    }
  });

  scheduleAnchor();
  if (document.fonts) document.fonts.ready.then(scheduleAnchor);
}());

/* (Rediseño 2026-10-29) Se retiró el revelado de fotos .rv-fx/[data-rv-foto]:
   las fotos entran con .rd-in (rediseno.js) y el formulario no se mueve. */
